import { TicketStatus } from '@packages/database/types';
import { FormSelect } from './FormSelect';
import { getStatusText } from '@/helpers/enumStylers';

export const TicketStatusDropdown = ({ required }: { required?: boolean }) => {
  const uneditableStatuses: TicketStatus[] = [
    TicketStatus.COMPLETED,
    TicketStatus.CANCELLED,
    TicketStatus.REJECTED,
    TicketStatus.FIELD_COMPLETE,
  ];
  const statuses = Object.values(TicketStatus).filter(
    (s) => !uneditableStatuses.includes(s),
  );
  return (
    <FormSelect
      name="status"
      label="Status"
      rules={required ? { required: 'Status is required' } : undefined}
      options={statuses.map((s) => ({
        value: s,
        label: getStatusText(s),
      }))}
    />
  );
};
